const CalendarTitleCell = ({ text }) => {
  return (
    <div className="bg-pale-orange font-chinese text-center p-1 text-custom-gray">
      {text ?? ""}
    </div>
  );
};

export default CalendarTitleCell;
